var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdhoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 60.6367H60.25V0.636719H0.25V60.6367Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0211 19.7104L53.9196 3.47455C52.9892 2.24768 51.5375 1.52768 49.9972 1.53126H6.02707C4.44737 1.53126 2.96438 2.29067 2.04199 3.57305L25.0211 19.6925C26.8139 20.9722 29.2202 20.9793 31.0211 19.7104Z",
    fill: "#BBDDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0211 19.7104L53.9196 3.47455C52.9892 2.24768 51.5375 1.52768 49.9972 1.53126H6.02707C4.44737 1.53126 2.96438 2.29067 2.04199 3.57305L25.0211 19.6925C26.8139 20.9722 29.2202 20.9793 31.0211 19.7104Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4112 37.3514H49.9873C51.2688 37.3684 52.5046 36.8741 53.4216 35.9786C54.3395 35.084 54.8625 33.8598 54.8769 32.5783V6.30365C54.8777 5.27828 54.541 4.28066 53.9186 3.46484L31.0201 19.7096C29.221 20.9884 26.8103 20.9884 25.0112 19.7096L2.04103 3.57231C1.46342 4.36574 1.14999 5.32216 1.14551 6.30365V32.5783C1.15984 33.8589 1.68193 35.0804 2.59715 35.9759C3.51237 36.8705 4.74551 37.3657 6.0261 37.3514H42.4112Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4112 37.3514H49.9873C51.2688 37.3684 52.5046 36.8741 53.4216 35.9786C54.3395 35.0839 54.8625 33.8598 54.8769 32.5783V6.30365C54.8777 5.27828 54.541 4.28066 53.9186 3.46484L31.0201 19.7096C29.221 20.9884 26.8103 20.9884 25.0112 19.7096L2.04103 3.57231C1.46342 4.36574 1.14999 5.32216 1.14551 6.30365V32.5783C1.15984 33.8589 1.68193 35.0804 2.59715 35.9759C3.51237 36.8705 4.74551 37.3657 6.0261 37.3514H42.4112Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2356 59.7427C52.138 59.7427 59.355 52.5257 59.355 43.6233C59.355 34.7209 52.138 27.5039 43.2356 27.5039C34.3332 27.5039 27.1162 34.7209 27.1162 43.6233C27.1162 52.5257 34.3332 59.7427 43.2356 59.7427Z",
    fill: "#BBDDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2356 59.7427C52.138 59.7427 59.355 52.5257 59.355 43.6233C59.355 34.7209 52.138 27.5039 43.2356 27.5039C34.3332 27.5039 27.1162 34.7209 27.1162 43.6233C27.1162 52.5257 34.3332 59.7427 43.2356 59.7427Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2358 36.457V50.7854",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 43.6211H50.3996",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhoc);
export default __webpack_public_path__ + "static/media/ADHOC.0eae966ec15273fec1b10a72d415125d.svg";
export { ForwardRef as ReactComponent };